// import logo from './logo.svg';
import './App.css';
import NameGeneratorNew from './components/NameGenerator';
// import BarcodeGenerator from './components/BarcodeGenerator';
// import QRCodeGenerator from './components/QRCodeGenerator';
import PasswordGenerator from './components/PasswordGenerator';
import AlertDismissible from './components/AlertDismissible';
// import JSONValidator from './components/JSONValidator';
import HtmlEditor from './components/HTMLEditor';
import EmailExtractor from './components/EmailExtractor';
import DomainExtractor from './components/DomainExtractor';
import ProductForm from './components/ProductForm';
import ImageUploader from './components/ImageUploader';
import MyComponent from './components/Multiselect';
// import MultiSelect from 'react-bootstrap-multiselect';
import Multiselect from './components/Multiselect';
import ProductCategoriesDropdown from './components/GetProductCategories';



function App() {
  // const password = "KfrbJAD9aN";
  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      <NameGeneratorNew/>
      {/* <h1>Barcode Generator App</h1>
      <BarcodeGenerator password={password} /> */}
      {/* <h1>QR Code Generator App</h1>
      <QRCodeGenerator password={password} /> */}
      {/* <PasswordGenerator/>
      <HtmlEditor/>
      <EmailExtractor/>
      <DomainExtractor/> */}
      {/* <JSONValidator/> */}
      <br/>
      {/* <AlertDismissible/> */}
      {/* <ProductCategoriesDropdown/> */}
      {/* <Multiselect/> */}
      {/* <ProductForm/> */}
      
      {/* <MyComponent/> */}
      {/* <ImageUploader/> */}
    </div>
  );
}

export default App;
